import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${
  environment.API_URL
}/v0/education_benefits_claims/0839`;

export const TITLE = 'Submit a Yellow Ribbon Program agreement request';
export const SUBTITLE =
  'Yellow Ribbon Program Agreement (Under Chapter 33 of title 38, United States Code) (VA Form 22-0839)';

export const CURRENCY_ENUM = [
  'AFN',
  'ALL',
  'DZD',
  'AOA',
  'ARS',
  'AMD',
  'AWG',
  'AUD',
  'AZN',
  'BSD',
  'BHD',
  'BDT',
  'BBD',
  'BYN',
  'BZD',
  'BMD',
  'BTN',
  'BOB',
  'BAM',
  'BWP',
  'BRL',
  'GBP',
  'BND',
  'BGN',
  'BIF',
  'KHR',
  'CAD',
  'CVE',
  'XCG',
  'KYD',
  'XOF',
  'XAF',
  'XPF',
  'CLP',
  'CLF',
  'CNY',
  'CNH',
  'COP',
  'KMF',
  'CDF',
  'CRC',
  'CUC',
  'CUP',
  'CZK',
  'DKK',
  'DJF',
  'DOP',
  'XCD',
  'EGP',
  'SVC',
  'ERN',
  'ETB',
  'EUR',
  'FKP',
  'FJD',
  'GMD',
  'GEL',
  'GHS',
  'GIB',
  'GTQ',
  'GNF',
  'GYD',
  'HTG',
  'HNL',
  'HKD',
  'HUF',
  'ISK',
  'INR',
  'IDR',
  'IRR',
  'IQD',
  'ELS',
  'JMD',
  'JPY',
  'JOD',
  'KZT',
  'KES',
  'KRW',
  'KWD',
  'KGS',
  'LAK',
  'LBP',
  'LSL',
  'LRD',
  'LYD',
  'MOP',
  'MKD',
  'MWK',
  'MYR',
  'MVR',
  'MRU',
  'MUR',
  'MXN',
  'DAR',
  'MDL',
  'MAD',
  'MZN',
  'MMK',
  'NAD',
  'NPR',
  'NZD',
  'NIO',
  'NGN',
  'ANG',
  'KPW',
  'NOK',
  'OMR',
  'PKR',
  'PAB',
  'PGK',
  'PYG',
  'PEN',
  'PHP',
  'PLN',
  'QAR',
  'RON',
  'RUB',
  'RWF',
  'WST',
  'STN',
  'SAR',
  'RSD',
  'SCR',
  'SLE',
  'SGD',
  'SIT',
  'SBD',
  'SOS',
  'ZAR',
  'LKR',
  'SHP',
  'SDG',
  'SRD',
  'SZL',
  'SEK',
  'CHF',
  'TWD',
  'TJS',
  'TZS',
  'THB',
  'TOP',
  'TTD',
  'TND',
  'TRY',
  'TMT',
  'UAH',
  'AED',
  'UYU',
  'USD',
  'UZS',
  'VUV',
  'VES',
  'VND',
  'YER',
  'ZMW',
];

export const CURRENCY_LABELS = {
  AFN: 'Afghanistan Afghani (AFN)',
  ALL: 'Albanian Lek (ALL)',
  DZD: 'Algerian Dinar (DZD)',
  AOA: 'Angolan Kwanza (AOA)',
  ARS: 'Argentine Peso (ARS)',
  AMD: 'Armenian Dram (AMD)',
  AWG: 'Aruban Florin (AWG)',
  AUD: 'Australian Dollar (AUD)',
  AZN: 'Azerbaijan New Manat (AZN)',
  BSD: 'Bahamian Dollar (BSD)',
  BHD: 'Bahraini Dinar (BHD)',
  BDT: 'Bangladeshi Taka (BDT)',
  BBD: 'Barbados Dollar (BBD)',
  BYN: 'Belarusian Ruble (BYN)',
  BZD: 'Belize Dollar (BZD)',
  BMD: 'Bermudian Dollar (BMD)',
  BTN: 'Bhutan Ngultrum (BTN)',
  BOB: 'Bolivian Boliviano (BOB)',
  BAM: 'Bosnian Mark (BAM)',
  BWP: 'Botswana Pula (BWP)',
  BRL: 'Brazilian Real (BRL)',
  GBP: 'British Pound (GBP)',
  BND: 'Brunei Dollar (BND)',
  BGN: 'Bulgarian Lev (BGN)',
  BIF: 'Burundi Franc (BIF)',
  KHR: 'Cambodian Riel (KHR)',
  CAD: 'Canadian Dollar (CAD)',
  CVE: 'Cape Verde Escudo (CVE)',
  XCG: 'Caribbean Guilder (XCG)',
  KYD: 'Cayman Islands Dollar (KYD)',
  XOF: 'CFA Franc BCEAO (XOF)',
  XAF: 'CFA Franc BEAC (XAF)',
  XPF: 'CFP Franc (XPF)',
  CLP: 'Chilean Peso (CLP)',
  CLF: 'Chilean Unidad de Fomento (CLF)',
  CNY: 'Chinese Yuan Renminbi (CNY)',
  CNH: 'Chinese Yuan Renminibi (offshore) (CNH)',
  COP: 'Colombian Peso (COP)',
  KMF: 'Comoros Franc (KMF)',
  CDF: 'Congolese Franc (CDF)',
  CRC: 'Costa Rica Colon (CRC)',
  CUC: 'Cuban Convertible Peso (CUC)',
  CUP: 'Cuban Peso (CUP)',
  CZK: 'Czech Koruna (CZK)',
  DKK: 'Danish Krone (DKK)',
  DJF: 'Djibouti Franc (DJF)',
  DOP: 'Dominican Peso (DOP)',
  XCD: 'East Caribbean Dollar (XCD)',
  EGP: 'Egyptian Pound (EGP)',
  SVC: 'El Salvador Colon (SVC)',
  ERN: 'Eritrean Nakfa (ERN)',
  ETB: 'Ethipoian Birr (ETB)',
  EUR: 'Euro (EUR)',
  FKP: 'Falkland IslandS Pound (FKP)',
  FJD: 'Fiji Dollar (FJD)',
  GMD: 'Gambian Dalasi (GMD)',
  GEL: 'Georgian Lari (GEL)',
  GHS: 'Ghanaian New Cedi (GHS)',
  GIB: 'Gibraltar Pound (GIB)',
  GTQ: 'Guatemalan Quetzal (GTQ)',
  GNF: 'Guinea Franc (GNF)',
  GYD: 'Guyanese Dollar (GYD)',
  HTG: 'Haitian Gourde (HTG)',
  HNL: 'Honduran Lempira (HNL)',
  HKD: 'Hong Kong Dollar (HKD)',
  HUF: 'Hungarian Forint (HUF)',
  ISK: 'Iceland Krona (ISK)',
  INR: 'Indian Rupee (INR)',
  IDR: 'Indonesian Rupiah (IDR)',
  IRR: 'Iranian Rial (IRR)',
  IQD: 'Iraqi Dinar (IQD)',
  ELS: 'Israeli New Shekel (ELS)',
  JMD: 'Jamaican Dollar (JMD)',
  JPY: 'Japanese Yen (JPY)',
  JOD: 'Jordanian Dinar (JOD)',
  KZT: 'Kazakhstan Tenge (KZT)',
  KES: 'Kenyan Shilling (KES)',
  KRW: 'Korean Won (KRW)',
  KWD: 'Kuwaiti Dinar (KWD)',
  KGS: 'Kyrgyzstanian Som (KGS)',
  LAK: 'Lao Kip (LAK)',
  LBP: 'Lebanese Pound (LBP)',
  LSL: 'Lesotho Loti (LSL)',
  LRD: 'Liberian Dollar (LRD)',
  LYD: 'Libyan Dinar (LYD)',
  MOP: 'Macau Pataca (MOP)',
  MKD: 'Macedonian Denar (MKD)',
  MWK: 'Malawi Kwacha (MWK)',
  MYR: 'Malaysian Ringgit (MYR)',
  MVR: 'Maldive Rufiyaa (MVR)',
  MRU: 'Mauritania Ouguiya (MRU)',
  MUR: 'Mauritius Rupee (MUR)',
  MXN: 'Mexican Peso (MXN)',
  DAR: 'Mines of Dalamia (DAR)',
  MDL: 'Moldovan Leu (MDL)',
  MAD: 'Morrocan Dirham (MAD)',
  MZN: 'Mozambique New Metical (MZN)',
  MMK: 'Myanmar Kyat (MMK)',
  NAD: 'Namibia Dollar (NAD)',
  NPR: 'Nepalese Rupee (NPR)',
  NZD: 'New Zealand Dollar (NZD)',
  NIO: 'Nicaraguan Cordoba Oro (NIO)',
  NGN: 'Nigerian Naira (NGN)',
  ANG: 'NL Antilillian Guilder (ANG)',
  KPW: 'North Korean Won (KPW)',
  NOK: 'Norwegigan Kroner (NOK)',
  OMR: 'Omani Rial (OMR)',
  PKR: 'Pakistan Rupee (PKR)',
  PAB: 'Panamanian Balboa (PAB)',
  PGK: 'Papua New Guinea Kina (PGK)',
  PYG: 'Paraguay Guarani (PYG)',
  PEN: 'Peruvian nuevo Sol (PEN)',
  PHP: 'Philippine Peso (PHP)',
  PLN: 'Polish Zloty (PLN)',
  QAR: 'Qatari Rial (QAR)',
  RON: 'Romanian New Leu (RON)',
  RUB: 'Russian Rouble (RUB)',
  RWF: 'Rwandan Franc (RWF)',
  WST: 'Samoan Tala (WST)',
  STN: 'Sao Tome and Principe Dobra (STN)',
  SAR: 'Saudi Riyal (SAR)',
  RSD: 'Serbian Dinar (RSD)',
  SCR: 'Seychelles Rupee (SCR)',
  SLE: 'Sierra Leone Leone (SLE)',
  SGD: 'Singapore Dollar (SGD)',
  SIT: 'Slovenian Tolar (SIT)',
  SBD: 'Solomon Islands Dollar (SBD)',
  SOS: 'Somali Shilling (SOS)',
  ZAR: 'South African Rand (ZAR)',
  LKR: 'Sri Lanka Rupee (LKR)',
  SHP: 'St. Helen Pound (SHP)',
  SDG: 'Sudanese Pound (SDG)',
  SRD: 'Suriname Dollar (SRD)',
  SZL: 'Swaziland Lilangeni (SZL)',
  SEK: 'Swedish Krona (SEK)',
  CHF: 'Swiss Franc (CHF)',
  TWD: 'Taiwan Dollar (TWD)',
  TJS: 'Tajikistan Somoni (TJS)',
  TZS: 'Tanzanian Shilling (TZS)',
  THB: 'Thai Baht (THB)',
  TOP: "Tongan Pa'anga (TOP)",
  TTD: 'Trinidad and Tobago Dollar (TTD)',
  TND: 'Tunisian Dinar (TND)',
  TRY: 'Turkish Lira (TRY)',
  TMT: 'Turkmenistan New Manat (TMT)',
  UAH: 'Ukraine Hryvnia (UAH)',
  AED: 'United Arab Emirates Dirham (AED)',
  UYU: 'Uruguayan Peso (UYU)',
  USD: 'US Dollar (USD)',
  UZS: 'Uzbekistan Som (UZS)',
  VUV: 'Vanatu Vatu (VUV)',
  VES: 'Venezuelan Bolivat Soberano (VES)',
  VND: 'Vietnamese Dong (VND)',
  YER: 'Yemen Rial (YER)',
  ZMW: 'Zambian Kwacha (ZMW)',
};

export const CURRENCY_SYMBOLS = {
  AFN: '؋',
  ALL: 'L',
  DZD: 'د.ج',
  AOA: 'Kz',
  ARS: '$',
  AMD: '֏',
  AWG: 'ƒ',
  AUD: 'A$',
  AZN: '₼',
  BSD: 'B$',
  BHD: 'ب.د',
  BDT: '৳',
  BBD: 'B$',
  BYN: 'Br',
  BZD: 'BZ$',
  BMD: 'B$',
  BTN: 'Nu.',
  BOB: 'Bs.',
  BAM: 'KM',
  BWP: 'P',
  BRL: 'R$',
  GBP: '£',
  BND: 'S$',
  BGN: 'лв',
  BIF: 'FBu',
  KHR: '៛',
  CAD: 'C$',
  CVE: 'Esc',
  XCG: 'XCG',
  KYD: 'CI$',
  XOF: 'CFA F',
  XAF: 'CFA F',
  XPF: '₣',
  CLP: '$',
  CLF: '',
  CNY: '¥',
  CNH: '¥',
  COP: '$',
  KMF: 'CF',
  CDF: 'FC',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CZK: 'Kč',
  DKK: 'kr',
  DJF: 'Fdj',
  DOP: 'RD$',
  XCD: 'EC$',
  EGP: '£',
  SVC: '$',
  ERN: 'Nfk',
  ETB: 'Br',
  EUR: '€',
  FKP: '£',
  FJD: 'FJ$',
  GMD: 'D',
  GEL: '₾',
  GHS: '₵',
  GIB: '£',
  GTQ: 'Q',
  GNF: 'FG',
  GYD: 'GY$',
  HTG: 'G',
  HNL: 'L',
  HKD: 'HK$',
  HUF: 'Ft',
  ISK: 'kr',
  INR: '₹',
  IDR: 'Rp',
  IRR: '﷼',
  IQD: 'ع.د',
  ELS: '₪',
  JMD: 'J$',
  JPY: '¥',
  JOD: 'د.ا',
  KZT: '₸',
  KES: 'KSh',
  KRW: '₩',
  KWD: 'د.ك',
  KGS: 'сом',
  LAK: '₭',
  LBP: 'ل.ل',
  LSL: 'L',
  LRD: 'L$',
  LYD: 'ل.د',
  MOP: 'MOP$',
  MKD: 'ден',
  MWK: 'MK',
  MYR: 'RM',
  MVR: 'MVR',
  MRU: 'UM',
  MUR: 'Rs',
  MXN: 'MX$',
  DAR: '',
  MDL: 'L',
  MAD: 'د.م',
  MZN: 'MTn',
  MMK: 'K',
  NAD: 'N$',
  NPR: '₨',
  NZD: 'NZ$',
  NIO: 'C$',
  NGN: '₦',
  ANG: 'ƒ',
  KPW: '₩',
  NOK: 'kr',
  OMR: 'ر.ع',
  PKR: '₨',
  PAB: 'B/',
  PGK: 'K',
  PYG: '₲',
  PEN: 'S/',
  PHP: '₱',
  PLN: 'zł',
  QAR: 'ر.ق',
  RON: 'lei',
  RUB: '₽',
  RWF: 'FRw',
  WST: 'WS$',
  STN: 'Db',
  SAR: 'ر.س',
  RSD: 'дин',
  SCR: 'S₨',
  SLE: 'Le',
  SGD: 'S$',
  SIT: 'tol',
  SBD: 'SI$',
  SOS: 'S',
  ZAR: 'R',
  LKR: 'Rs',
  SHP: '£',
  SDG: 'ج.س',
  SRD: 'SR$',
  SZL: 'L',
  SEK: 'kr',
  CHF: 'CHF',
  TWD: 'NT$',
  TJS: 'ЅМ',
  TZS: 'TSh',
  THB: '฿',
  TOP: 'T$',
  TTD: 'TT$',
  TND: 'د.ت',
  TRY: '₺',
  TMT: 'm',
  UAH: '₴',
  AED: 'د.إ',
  UYU: '$U',
  USD: '$',
  UZS: 'лв',
  VUV: 'VT$',
  VES: 'Bs.S',
  VND: '₫',
  YER: '﷼',
  ZMW: 'ZK',
};
